export default [
  {
    path: "/uhDDU8uC7pmiBSTKmNAk",
    children: [
      {
        path: "Rep",
        name: "schoolRep",
        meta: {
          title: "SCHOOL REP",
          authRequired: true,
          acc: ['y46010']
        },
        component: () => import("../views/schoolRep/index.vue"),
      },
      {
        path: "new",
        name: "newSchoolRep",
        meta: {
          title: "NEW SCHOOL REP",
          authRequired: true,
          acc: ['y56143']
        },
        component: () => import("../views/schoolRep/new.vue"),
      },
      {
        path: "view/:ert",
        name: "viewRep",
        meta: {
          title: "VIEW SCHOOL REP",
          authRequired: true,
          acc: ['y93601']
        },
        component: () => import("../views/schoolRep/view.vue"),
      },
      {
        path: "edit/:ert/:tr",
        name: "editRep",
        meta: {
          title: "Edit SCHOOL REP",
          authRequired: true,
          // acc: ['y31830']
        },
        component: () => import("../views/schoolRep/edit.vue"),
      },
      {
        path: "edit-p/:ert/:tr",
        name: "editRepPassword",
        meta: {
          title: "Edit SCHOOL REP",
          authRequired: true,
          // acc: ['y31830']
        },
        component: () => import("../views/schoolRep/editPassword.vue"),
      },
    ],
  },
];
